// hotsport start
function hosport_click(item) {
  item.addEventListener("click", (event) => {
      let hide_content = document.querySelectorAll("[data-host-port-content]");
    if(document.querySelector(event.target.getAttribute('data-hotsport-click')).classList.contains('hidden')){
      hide_content.forEach(b => {
         b.classList.add("hidden");
      });
      document.querySelector(event.target.getAttribute('data-hotsport-click')).classList.remove("hidden");
    }else{
      document.querySelector(event.target.getAttribute('data-hotsport-click')).classList.add("hidden");
    }
  });        
}
let host_poart_link  = document.querySelectorAll("[data-hotsport-click]");
host_poart_link.forEach(hosport_click);
// hotsport end

//faq scroll logic 

document.querySelectorAll('.faq_tab_btn a').forEach(tab => {
  tab.addEventListener('click', function(e) {
    e.preventDefault(); // Prevent default anchor behavior

    // Get the href attribute of the clicked tab to find the target accordion
    const selectedHandle = this.getAttribute('data-hendles');
    console.log("selectedHandle:", selectedHandle);

    // Find the corresponding accordion title or panel with matching data-title attribute
    const targetAccordion = document.querySelector(`.main_tab_name[data-title="${selectedHandle.slice(1)}"]`);
    console.log("targetAccordion:", targetAccordion);

    // If a matching accordion section is found, scroll to it smoothly
    if (targetAccordion) {
      targetAccordion.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

//faq toggle logic 

/* document.querySelectorAll(".main-faq-wapper").forEach((item) => {
  item.querySelector(".faq_Click").addEventListener("click", () => {
    // Close other open tabs
    document.querySelectorAll(".main-faq-wapper.open").forEach((openItem) => {
      if (openItem !== item) {
        openItem.classList.remove("open");
        openItem.querySelector(".accordion__content").style.display = "none";
      }
    });

    // Toggle current tab
    const content = item.querySelector(".accordion__content");
    item.classList.toggle("open");
    content.style.display = item.classList.contains("open") ? "block" : "none";
  });
}); */

// ratgeber page tab logic 

document.addEventListener('DOMContentLoaded', function () {
  // Get all tab buttons and content sections
  const tabButtons = document.querySelectorAll('.tab-list-button .button');
  const tabContents = document.querySelectorAll('.tab-list-section [data-title]');

  // Function to show/hide tab content based on the active tab
  function updateTabContent(activeTrigger) {
    tabContents.forEach(content => {
      const contentTitle = content.getAttribute('data-title');
      content.style.display = contentTitle === activeTrigger ? 'block' : 'none';
    });
  }

  if (tabButtons.length > 0) {
    tabButtons.forEach(button => {
      button.addEventListener('click', function () {
        const trigger = this.getAttribute('data-tab-trigger');

        // Remove 'active' class from all buttons
        tabButtons.forEach(btn => btn.classList.remove('active'));

        // Add 'active' class to the clicked button
        this.classList.add('active');

        // Update tab content based on the clicked button's trigger
        updateTabContent(trigger);
      });
    });

    // Initially hide all content sections except the first one
    tabContents.forEach((content, index) => {
      content.style.display = index === 0 ? 'block' : 'none';
    });

    // Set the initial active tab content
    updateTabContent(tabButtons[0].getAttribute('data-tab-trigger'));
  }
});


// ratgeber page tab faq 
 function toggleAnswer(questionElement) {
    const answerElement = questionElement.nextElementSibling;

    // Toggle the display of the answer
    if (answerElement.style.display === "none" || answerElement.style.display === "") {
      answerElement.style.display = "block"; // Show the answer
      questionElement.classList.add("open"); // Add the 'open' class to the question
    } else {
      answerElement.style.display = "none"; // Hide the answer
      questionElement.classList.remove("open"); // Remove the 'open' class from the question
    }
  }

  // Initialize all FAQ answers to be hidden
  document.addEventListener('DOMContentLoaded', function () {
    const faqAnswers = document.querySelectorAll('.faq-answer');
    faqAnswers.forEach(answer => {
      answer.style.display = 'none'; // Ensure all answers are hidden on page load
    });
  });
// faq tabs toggal start
/* function togal_tabs (item) {
  item.addEventListener("click", () => {
     toggal_all_tabs(item.getAttribute('data-faq_content'));
  });        
}
function toggal_all_tabs(tabs_data){
  let tabs_button = document.querySelectorAll("[data-faq_content]");
  tabs_button.forEach(b => {
    if(b.getAttribute('data-faq_content') == tabs_data){
      if(b.classList.contains('is_open')){
         b.classList.remove("is_open");    
        }else{
         b.classList.add("is_open");
        }
    }else{
       b.classList.remove("is_open");
    }
  });             
}
function faq_taggol() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");
  tabs_title.forEach(togal_tabs);
}
faq_taggol();
// faq tabs toggal end

// faq tabs toggal content start
function tab_mai_mappert(item) {
  item.addEventListener("click", () => {
     toggal_all_tabs_content(item.getAttribute('data-hendles'));
  });
}
function toggal_all_tabs_content(tabs_data){
  let tabs_content_toggel = document.querySelectorAll("[data-hendles]");
  tabs_content_toggel.forEach(b => {
    if(b.getAttribute('data-hendles') == tabs_data){
         b.classList.add("active");
        document.querySelector(b.getAttribute('data-hendles')).classList.remove("hidden");
        // document.querySelector(b.getAttribute('data-hendles')).classList.add("active");
    }else{
       b.classList.remove("active");
      if (document.querySelector(b.getAttribute('data-hendles'))) {
         document.querySelector(b.getAttribute('data-hendles')).classList.add("hidden");
         // document.querySelector(b.getAttribute('data-hendles')).classList.remove("active");
      }                                 
    }
  });
}
let tabs_content  = document.querySelectorAll("[data-hendles]");
tabs_content.forEach(tab_mai_mappert); */
// faq tabs toggal content end

// glossar page scroll

const filter_link = document.querySelectorAll('.filter') || null
if(filter_link){
    filter_link.forEach(tab => {
      tab.addEventListener('click', function(e) {
        e.preventDefault(); // Prevent default anchor behavior
    
       
        // Get the letter from the clicked tab
        const selectedLetter = this.getAttribute('data-letter');
        
        // Find the corresponding accordion title or panel with matching data-letter-cont attribute
        const targetAccordion = document.querySelector(`.heading-glossar[data-letter-cont="${selectedLetter}"]`);
    
        // If a matching accordion section is found, scroll to it smoothly
        if (targetAccordion) {

           filter_link.forEach(a => {
              a.classList.remove("active");
            });
            this.classList.add("active");
          
          targetAccordion.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
}


// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end


/*==== menu hover Js======*/

 let items = document
     .querySelector(".header__inline-menu")
     .querySelectorAll("details");

      items.forEach(item => {
        item.addEventListener("mouseover", () => {
          item.setAttribute("open", true);
        item.querySelector("ul").addEventListener("mouseleave", () => {
            item.removeAttribute("open");
        });
          item.addEventListener("mouseleave", () => {
              item.removeAttribute("open");
          });
        });
      });


/*==== menu hover Js======*/

function collection_filter(){
     const open_buttons = document.querySelectorAll("[dara-filter-open-cust]");
  if(open_buttons){
        open_buttons.forEach((button) => {
          button.addEventListener("click", (e) => {
             e.preventDefault();
               button.closest('#FacetFiltersForm').querySelector("[data-filter-main-blocks]").classList.toggle('show-cust-filter');
                 document.body.classList.toggle('open-cust-filter');
         });
        });
  }
}


// ---------------- custom variant select click
  function click_custom() {
    const customVariants = document.querySelectorAll('.swatch-input__label');

        if (customVariants) {
          customVariants.forEach(customVariant => {
            customVariant.addEventListener('click', function () {
              // Toggle the 'active_dropdown' class on the closest parent 'ul' element
              this.closest('ul').classList.toggle("active_dropdown");
            });
          });
        }
  }


function ALAcheckCatorgy() {
isALARenderedCategory = setInterval(function () {
   var color_swatches = document.querySelectorAll('.customily_option.color_swatches_div') || null;
   const main_customli_option_active =  document.querySelectorAll('.customily-main-app .customily_option[visually-hidden]') || null;
    const main_customli_option =  document.querySelectorAll('.customily-main-app .customily_option') || null;
  const main_customli_hide_text =  document.querySelector('[data-custom-app-text]') || null;
    
    // customALACategory();
    // hidden_remove();
  
  // if(color_swatches.length > 1 ){
  //   clearInterval(isALARenderedCategory);
  //   customALACategory(); 
  //   hidden_remove();
  // }
  
  if(main_customli_hide_text && main_customli_option_active.length < main_customli_option.length){
     clearInterval(isALARenderedCategory);
    const is_app_options = document.querySelector('.customily_option.color_swatches_div_select select') || null;
    if(is_app_options) is_app_options.addEventListener('change', customALACategory);
    customALACategory();
    hidden_remove();
    getFontFamily();
  }
  }, 2000); 
} 
ALAcheckCatorgy();
function hidden_remove() {
  const main_customli_option_active =  document.querySelectorAll('.customily-main-app .customily_option[visually-hidden]') || null;
const main_customli_option =  document.querySelectorAll('.customily-main-app .customily_option') || null;
  const main_customli_hide_text =  document.querySelector('[data-custom-app-text]') || null;
  // console.log("jjjj",main_customli_hide_text && main_customli_option_active.length < main_customli_option.length)
  if(main_customli_hide_text && main_customli_option_active.length < main_customli_option.length){
      const main_select_varent = document.querySelectorAll('variant-selects select') || null;
    main_select_varent.forEach((element) => {
      if(element.value == 'keine Gravur'){
       main_customli_hide_text.classList.add('hidden');
      return
      }else{
        main_customli_hide_text.classList.remove('hidden');
      } 
    });
  }
  customALACategory();
}
function customALACategory() {
  // customize app JS color 1
  var color_swatches = document.querySelectorAll('.customily_option.color_swatches_div');
    // console.log("color_swatches",color_swatches)
  if(color_swatches){
    clearInterval(isALARenderedCategory);
    color_swatches.forEach(color_swatch => {
      // console.log(color_swatch);
        color_swatch.querySelector('label').classList.add('swatches_label');
      color_swatch.querySelector('label').addEventListener('click', function () {
        var div_hide_show = color_swatch.querySelector('.cl-accordion.cl-option-content');
        color_swatch.classList.toggle('swatches_show');
      });
    });
  }
}

function getFontFamily() {
  var fontFamily;
  document.addEventListener('click', function(e) {
    if (e.target.matches('.csh-dropdown-item-text')) {
      // console.log("e",e.target.innerText);
      fontFamily = e.target.innerText;
      var show_input = document.querySelectorAll('[name^="properties[Dein persönlicher Gravurtext"]');
      if (show_input.length) {
        show_input.forEach(input => {
          input.style.fontFamily = fontFamily;
        });
      }
      // MainDiv.querySelectorAll('[class^="Accordion_panel_"]');
      // console.log("show_input",show_input);
    }
    
    if (e.target.matches('[name^="properties[Dein persönlicher Gravurtext"]')) {
      var show_input = document.querySelectorAll('[name^="properties[Dein persönlicher Gravurtext"]');
      if (show_input.length) {
        show_input.forEach(input => {
          input.addEventListener("input", function () {
            if (fontFamily != null) {
            console.log("fontFamily",fontFamily)
               input.style.fontFamily = fontFamily; 
            }            
          });
        });
      }
    }    
  });
}

(function() { 

const popup_open = document.querySelectorAll('[data-popup-open]') || null;
  if(popup_open){
      popup_open.forEach(b => {
      b.addEventListener("click", (event) => {
        event.preventDefault();
           const main_popup = document.querySelector(event.target.hash) || null;
        console.log(main_popup);
          if(!main_popup) return;
                 main_popup.classList.add("open"); 
                 document.body.classList.add("popup_open");
        });
     });
  }  

  const popup_close = document.querySelectorAll('[data-popup-close]') || null;
  if(popup_close){
      popup_close.forEach(b => {
      b.addEventListener("click", (event) => {
        event.preventDefault();
           const main_popup = event.target.closest('[data-poup]') || null;
          if(!main_popup) return;
                 main_popup.classList.remove("open"); 
                 document.body.classList.remove("popup_open");
        });
     });
  } 

  faq_taggol();
  collection_filter();
  click_custom();

// PDP unavalable varient start

  // if(document.querySelector('body').classList.contains('template-product')){

  //       const variantSelects = (document.querySelector('variant-selects')) ? document.querySelector('variant-selects') : document.querySelector('variant-radios') || null;    
  //       if(variantSelects){
  //         const pickerType = (variantSelects.querySelectorAll('fieldset').length > 0) ? 'radios' : 'selects' || null;
  //         const fieldsets = (pickerType == 'radios') ? Array.from(variantSelects.querySelectorAll('fieldset')) : Array.from(variantSelects.querySelectorAll('.product-form__input--dropdown')) || null;
  //         const productJson = JSON.parse(variantSelects.querySelector('[type="application/json"]').textContent) || null;
  //         let selectedOptions = [];
  //         variantSelects.addEventListener('change', rebuildOptions);
  //         rebuildOptions();
  //       }
        
  //       function validCombo(inputValue, optionLevel) {
  //         if(productJson){
  //         for(let i = 0; i < productJson.length; i++) {
  //           if(optionLevel == 1){
  //             if (productJson[i].option1 == selectedOptions[0] && productJson[i].option2 == inputValue) {  return true; }
  //           } else {
  //             if (productJson[i].option1 == selectedOptions[0] && productJson[i].option2 == selectedOptions[1] && productJson[i].option3 == inputValue) {  return true; }
  //           }
  //         }
  //         }
  //       }
        
  //       function rebuildOptions() {
  //           selectedOptions = fieldsets.map((fieldset) => {
  //               return (pickerType == 'radios') ? Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value : Array.from(fieldset.querySelectorAll('select'), (select) => select.value);
  //           });
  //           for(let optionLevel = 1, n = fieldsets.length; optionLevel < n; optionLevel++) {
  //               const inputs = (pickerType == 'radios') ? fieldsets[optionLevel].querySelectorAll('input') : fieldsets[optionLevel].querySelectorAll('option');
        
  //               inputs.forEach(input => {
  //               input.disabled = (validCombo(input.value,optionLevel)) ? false : true;
  //               if(pickerType == 'radios'){
  //                   const label = fieldsets[optionLevel].querySelector(`label[for="${input.id}"]`);
        
  //                   label.style.display = (input.disabled) ? "none" : ""; //Hide the option, or comment this line out and use the following lines to style it..
  //                   //label.style.opacity = (input.disabled) ? 0.5 : 1;
  //                   //label.style.borderStyle = (input.disabled) ? "dashed" : "solid";
  //                   //label.style.textDecoration = (input.disabled) ? "none" : "";
  //               } else {
  //                   input.hidden = (validCombo(input.value,optionLevel)) ? false : true;
  //               }
  //               });
  //           }
  //           for (let optionLevel = 1, fieldsetsLength = fieldsets.length, change = false; optionLevel < fieldsetsLength && !change; optionLevel++) {
  //               if(pickerType == 'radios'){
  //               if(fieldsets[optionLevel].querySelector('input:checked').disabled === true) {
  //                   change = (fieldsets[optionLevel].querySelector('input:not(:disabled)').checked = true);
  //               }
  //               } else {
  //               if(fieldsets[optionLevel].querySelector('option:checked').disabled === true) {
  //                 if(fieldsets[optionLevel].querySelector('option:not(:disabled)')){
  //                   change = (fieldsets[optionLevel].querySelector('option:not(:disabled)').selected = "selected");
  //                 }
  //               }
  //               }
  //               if(change) variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
  //           }
  //       }

  // }

// PDP unavalable varient end 

})();


 